<script lang="ts">
  import type { Snippet } from "svelte"
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"

  type Props = {
    title: string
    description?: string
    helpModalTextId?: string
    buttonSnippet?: Snippet | null
    children?: Snippet | null
  }

  const {
    title,
    description,
    helpModalTextId = "",
    buttonSnippet = null,
    children = null,
  }: Props = $props()
</script>

<section class="create-workflow-step form light">
  <SectionTitle
    small={true}
    {title}
    {description}
    {helpModalTextId}
    helpModalTooltip="Hilfe zu diesem Schritt öffnen"
    darkMode={true}
    styleOuter="margin-top: 0; margin-bottom: 0.35rem;"
    {buttonSnippet}
  />
  <div class="create-workflow-step-content">
    {@render children?.()}
  </div>
</section>

<style>
  .create-workflow-step {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .create-workflow-step-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
